import { useQuery } from '@tanstack/react-query';
import { jsonGet } from '../api/jsonRequest';
import { queryKeys } from '../query/queryKeys';

export function useRoles({ enabled = true } = {}) {
    return useQuery({
        queryKey: queryKeys.roles.list(),
        queryFn: () => jsonGet('/api/Account/GrabAllRoles'),
        enabled,
        staleTime: 5 * 60 * 1000,
    });
}
